import React from 'react';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log({ error });
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log({ error, errorInfo });
  }

  render() {
    
    const styles = {
      wraperr_box: {
        'height': '100vh',
        'display': 'flex'
      },
      err_box: {
        'color': 'grey',
        'box-shadow': 'rgb(17 12 46 / 15%) 0px 48px 100px 0px',
        'width': '40%',
        'margin': 'auto',
        'padding': '10px 40px 50px',
        'text-align': 'center'
      },
      button: {
        'background-color': '#4CAF50',
        'border': 'none',
        'color': 'white',
        'padding': '15px 32px',
        'text-align': 'center',
        'text-decoration': 'none',
        'display': 'inline-block',
        'font-size': '16px',
        'cursor': 'pointer',
        'border-radius': '6px'

      },
      h2titleohno :{
        'color': '#000',
        'font-size': '36px'
      },
      ohnosubtitle:{
        'font-size': '22px',
        'font-weight': '500',
        'padding': '15px 0 0'
      }
    };

    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={styles.wraperr_box}>
          <div style={styles.err_box}><br /><br />
            <h2 style={styles.h2titleohno}>Ohh No</h2>
            <h3 style={styles.ohnosubtitle}>Something Went Wrong</h3>
            <br />
            <br />
            <a style={styles.button} onClick={() => window.location.reload()}>Go to Home</a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js